import { render, staticRenderFns } from "./VideosTable.vue?vue&type=template&id=566f299f&"
import script from "./VideosTable.vue?vue&type=script&lang=js&"
export * from "./VideosTable.vue?vue&type=script&lang=js&"
import style0 from "./VideosTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports